import { takeUntil } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService implements OnDestroy {
  public sidebarVisible: boolean = true;

  public sidebarActiveTab: number;
  public sidebarActiveTabChange = new ReplaySubject<number>(1);
  unSubscribeAll$: Subject<void> = new Subject<void>();

  constructor() {
    this.sidebarActiveTabChange
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((tabIndex) => {
        this.sidebarActiveTab = tabIndex;
      });
  }

  toggle() {
    setTimeout(function () {
      this.sidebarVisible = !this.sidebarVisible;
    }, 10);
  }

  hideSidebar(): void {
    this.sidebarVisible = false;
    setTimeout(function () {
      this.sidebarVisible = false;
    }, 10);
  }

  showSidebar(): void {
    this.sidebarVisible = true;
    setTimeout(function () {
      this.sidebarVisible = true;
    }, 10);
  }

  getStatus() {
    return this.sidebarVisible;
  }

  tabChange(tabIndex: number) {
    this.sidebarActiveTabChange.next(tabIndex);
  }

  ngOnDestroy() {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }
}
